import ReactMarkdown from 'react-markdown';
import PropTypes from 'prop-types';
import { useStatsigClient } from '@statsig/react-bindings';

import { GATES } from '@constants';
import { AISummaryIcon, Announcement } from '@utilities';

import styles from './_index.module.scss';

const VideoHighlights = ({ expiresAt, highlightsUrl, summaryText }) => {
  const { client } = useStatsigClient();
  const isEnabled = client.checkGate(GATES.VIDEO_SIZZLE_REEL);
  const expiresAtTimestamp = expiresAt ? Date.parse(expiresAt) : Number.NaN;
  const isHighlightsUrlExpired =
    Number.isFinite(expiresAtTimestamp) && expiresAtTimestamp <= Date.now();
  const usableHighlightsUrl = isHighlightsUrlExpired ? null : highlightsUrl;

  if (!isEnabled || (!usableHighlightsUrl && !summaryText)) {
    return null;
  }

  return (
    <Announcement
      className={styles['video-highlights']}
      hasClose
      header="Video Highlights"
      icon={<AISummaryIcon className={styles['video-highlights-icon']} />}
      text={
        <div className={styles['video-highlights-content']}>
          {usableHighlightsUrl && (
            // The highlights API does not currently provide a caption track.
            // eslint-disable-next-line jsx-a11y/media-has-caption
            <video
              aria-label="Video highlights reel"
              className={styles['video-highlights-player']}
              controls
              data-testid="video-highlights-player"
              src={usableHighlightsUrl}
            />
          )}
          {summaryText && (
            <div className={styles['video-highlights-summary']}>
              <ReactMarkdown>{summaryText}</ReactMarkdown>
            </div>
          )}
        </div>
      }
      variant="ai"
    />
  );
};

VideoHighlights.propTypes = {
  expiresAt: PropTypes.string,
  highlightsUrl: PropTypes.string,
  summaryText: PropTypes.string,
};

export default VideoHighlights;
